import { gql } from 'apollo-angular'

import { AUTHOR_EXTENDED_FIELDS } from '../../fragments/author.fragments'
import { CATEGORY_BASIC_FIELDS } from '../../fragments/category.fragment'

export const GET_ARTICLES_BY_MAGAZINE_ID = gql`
  ${AUTHOR_EXTENDED_FIELDS}
  ${CATEGORY_BASIC_FIELDS}
  query getArticlesByMagazineId(
    $magazineId: JSON!
    $page: Int
    $limit: Int
    $additionalWhere: Article_where_and
    $sort: String
  ) {
    Articles(
      where: {
        AND: [
          { magazine: { equals: $magazineId } }
          { published_at: { not_equals: null } }
          $additionalWhere
        ]
      }
      page: $page
      limit: $limit
      sort: $sort
    ) {
      docs {
        id
        title
        slug
        content_preview
        published_at
        article_type
        users {
          authors {
            ...AuthorExtendedFields
          }
          creators {
            ...AuthorExtendedFields
          }
        }
        edition {
          published_at
          year
          volume
          edition_version
        }
        magazine {
          manual_title
          manual_description
          manual_url
        }
        groupedUsers {
          key
          authors {
            ...AuthorBasicFields
          }
        }
        categories {
          ...CategoryBasicFields
        }
      }
      totalDocs
      page
      totalPages
    }
  }
`
